module.exports = __webpack_public_path__ + "media/bundles/YoupiJob/assets/images/svg-icons/Badges/Payments/VisaMastercard-bf153addd28a9190085b378cc0b949ce.svg";